﻿import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { getInsuranceMeta } from '../../../DataHelpers/lfDataHelpers';

import {iconCode, mediaQuery, clearFix} from '../../../Style/cssHelpers';
import definitions from '../../../Style/LfStyleDefinitions';

class InsuranceHeading extends React.Component {
    static get propTypes() {
        return {
            registration: PropTypes.object.isRequired
        }
    }

    render() {
        let registrationSuffix, displayName;
        const registration = this.props.registration; 

        if (registration.targetGroupName === 'djur') {
            registrationSuffix = registration.animalGivenName;
            displayName = registration.displayName; 
        } else {
            const regMeta = getInsuranceMeta(this.props.registration.insuranceName); 

            const targetInfo = this.props.registration.isCoinsured
                ? this.props.data.coinsuredInfo
                : this.props.data.memberInfo;

            registrationSuffix = targetInfo && targetInfo.firstName && targetInfo.lastName
                ? `${targetInfo.firstName} ${targetInfo.lastName}`
                : (this.props.registration.isCoinsured ? 'medförsäkrad' : 'medlem');

            displayName = regMeta ? regMeta.displayNameHeading : registration.displayName;
        }

        return (
            <div>
                <Heading>{displayName}</Heading>
                {registrationSuffix &&
                    <React.Fragment>
                        <Separator>&nbsp;-&nbsp;</Separator>{registrationSuffix}
                    </React.Fragment>
                }
            </div>
        );
    }
}

// state

const mapStateToProps = (state) => {
    return {
        data: state.preregistrationPageData
    };
};

export default connect(mapStateToProps, () => ({}))(InsuranceHeading);

// styles 

const Heading = styled.h4`
    display: inline-block; 
    ${mediaQuery.xsmall(`
        display: block;
    `)}

    font-family: ${definitions.fonts.main};
    font-size: 18px; 
    ${mediaQuery.large(`
        font-size: 16px;
    `)}
    font-weight: bold; 
`;

const Separator = styled.span`
    display: inline-block; 
    ${mediaQuery.xsmall(`
        display: none;
    `)}
`;